/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as InzeratRouteImport } from './routes/inzerat'
import { Route as IndexRouteImport } from './routes/index'

const InzeratRoute = InzeratRouteImport.update({
  id: '/inzerat',
  path: '/inzerat',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/inzerat': typeof InzeratRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/inzerat': typeof InzeratRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/inzerat': typeof InzeratRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/inzerat'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/inzerat'
  id: '__root__' | '/' | '/inzerat'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  InzeratRoute: typeof InzeratRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/inzerat': {
      id: '/inzerat'
      path: '/inzerat'
      fullPath: '/inzerat'
      preLoaderRoute: typeof InzeratRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  InzeratRoute: InzeratRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
